/**
 * Create Note Button Component
 * Button that opens modal to create a new note
 */

import React, { useState } from 'react';
import { Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import NoteFormModal from './NoteFormModal';

const CreateNoteButton = ({ companyId, invoiceId, onNoteCreated }) => {
  const [showModal, setShowModal] = useState(false);

  const handleSuccess = () => {
    setShowModal(false);
    onNoteCreated();
  };

  return (
    <>
      <Button
        variant="primary"
        size="sm"
        onClick={() => setShowModal(true)}
      >
        <FontAwesomeIcon icon={faPlus} className="me-1" />
        Ny anteckning
      </Button>

      <NoteFormModal
        show={showModal}
        onHide={() => setShowModal(false)}
        companyId={companyId}
        invoiceId={invoiceId}
        onSaved={handleSuccess}
      />
    </>
  );
};

export default CreateNoteButton;
